// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { updateStoredModulationDetails } from 'redux/modules/databaseDetails'

const updateModulationsWithMatchingRadioCurveSetId = modulationDetails => (dispatch, getState) => {
  const { radioCurveSet } = modulationDetails

  // if no radioCurveSet is assigned, or if a brand new curve set was given, just get outta here
  if (radioCurveSet === null || radioCurveSet.radioCurveSetId === null) {
    return
  }

  // loop over all the modulations for this radio stored in databaseDetails.
  // look for any modulations which also use the same filter reference code
  const modulationsWithRadioCurveSetId = (
    getState().databaseDetails.getIn(['initialValues', 'radioModulations'])
      .filter(d => (
        d.get('index') !== modulationDetails.index &&
        d.getIn(['radioCurveSet', 'radioCurveSetId']) === radioCurveSet.radioCurveSetId
      ))
  )

  // loop over these modulations and make sure to update their stored curve points to match the defined curve points from modulationDetails
  // NOTE - we .toJS() here because the reducer will expect the value to set as a POJO
  return Promise.all(modulationsWithRadioCurveSetId.map(modulation => (
    dispatch(updateStoredModulationDetails(
      modulation.set('radioCurveSet', fromJS(radioCurveSet)).toJS()
    ))
  )))
}

export default updateModulationsWithMatchingRadioCurveSetId
